import React from 'react';
import {
  Box,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  Text,
  Badge,
  Spinner,
  Center,
} from '@chakra-ui/react';

const MyWorks = ({ data, loading }) => {
  // ✅ Extract from dashboard data
  const tasks =
    data?.myWork?.map((t) => ({
      id: t.issue_key,
      name: t.issue_title,
      status: t.issue_status,
    })) ?? [];

  const getStatusColor = (status) => {
    switch (status) {
      case 'TO DO':
        return 'blue';
      case 'IN PROGRESS':
        return 'yellow';
      case 'REVIEW':
        return 'purple';
      case 'DONE':
        return 'green';
      default:
        return 'gray';
    }
  };

  return (
    <>
      <Text fontSize="md" fontWeight="semibold" mb={1}>
        My Works
      </Text>

      <Box
        bg="white"
        borderRadius="lg"
        p={2}
        boxShadow="sm"
        borderWidth="1px"
        borderColor="gray.200"
        h="310px"
        display="flex"
        flexDirection="column"
      >
        {loading ? (
          <Center flex="1">
            <Spinner />
          </Center>
        ) : (
          <Box overflowY="auto" maxH="full">
            <Table variant="simple" size="sm" zIndex={0}>
              <Thead position="sticky" top={0} bg="white" zIndex={0}>
                <Tr>
                  <Th>Task ID</Th>
                  <Th>Task Name</Th>
                  <Th>Status</Th>
                </Tr>
              </Thead>
              <Tbody>
                {tasks.length === 0 ? (
                  <Tr>
                    <Td colSpan={3} textAlign="center" color="gray.500">
                      No tasks found
                    </Td>
                  </Tr>
                ) : (
                  tasks.map((task) => (
                    <Tr key={task.id}>
                      <Td fontWeight="medium">{task.id}</Td>
                      <Td>{task.name}</Td>
                      <Td>
                        <Badge
                          colorScheme={getStatusColor(task.status)}
                          borderRadius="md"
                          px={2}
                        >
                          {task.status}
                        </Badge>
                      </Td>
                    </Tr>
                  ))
                )}
              </Tbody>
            </Table>
          </Box>
        )}
      </Box>
    </>
  );
};

export default MyWorks;